import { createContext, type JSX, useContext } from 'solid-js'
import { MainModule } from '../../../features/main-module'
import type { GetSubscribersInteractor } from '../../../features/subscribers/domain/interactors/get-subscribers.interactor'
import type { GetSubscriberFiltersInteractor } from '../../../features/subscribers/domain/interactors/get-subscriber-filters.interactor'

interface SubscribersContextType {
  getSubscribers: GetSubscribersInteractor
  getSubscriberFilters: GetSubscriberFiltersInteractor
}

const CorisSubscribersContext = createContext<SubscribersContextType>()

export const CorisSubscribersProvider = (props: { children: JSX.Element }): JSX.Element => {
  const subscribersComponent = MainModule.getSubscribersComponent()

  const defaultContextValue: SubscribersContextType = {
    getSubscribers: subscribersComponent.provideGetSubscribers(),
    getSubscriberFilters: subscribersComponent.provideGetSubscriberFilters()
  }

  return (
    <CorisSubscribersContext.Provider value={defaultContextValue}>{props.children}</CorisSubscribersContext.Provider>
  )
}

export const useCorisSubscribers = (): SubscribersContextType => {
  const context = useContext(CorisSubscribersContext)
  if (!context) {
    throw new Error('useCorisSubscribers must be used inside a CorisSubscribersProvider')
  }
  return context
}
